module.exports = __webpack_public_path__ + "img/play-icon.bc62dac6.svg";